import { SharedLanguageService } from '@language';
import { AdvancedSearchTranslations } from '../../public_api';

export const advancedSearchTranslationsFactory: (translate: SharedLanguageService) => AdvancedSearchTranslations = (
    translate: SharedLanguageService
) => ({
    action: {
        title: translate.instant('advanced-search.action.title')
    },
    dialog: {
        title: translate.instant('advanced-search.action.title')
    },
    advancedSearch: {
        actions: {
            cancel: {
                label: translate.instant('actions.common.cancel')
            },
            search: {
                label: translate.instant('actions.search')
            }
        },
        includeExclude: {
            label: translate.instant('advanced-search.include-exclude.label'),
            include: translate.instant('advanced-search.include-exclude.include'),
            exclude: translate.instant('advanced-search.include-exclude.exclude')
        },
        label: {
            title: translate.instant('advanced-search.label.title'),
            helpText: translate.instant('advanced-search.label.helpText')
        },
        type: {
            label: translate.instant('advanced-search.type.label'),
            placeholder: translate.instant('advanced-search.type.placeholder')
        },
        value: {
            label: translate.instant('advanced-search.value.label'),
            placeholder: translate.instant('advanced-search.value.placeholder'),
            date: {
                from: translate.instant('advanced-search.value.date.from'),
                to: translate.instant('advanced-search.value.date.to'),
                year: translate.instant('advanced-search.value.date.year'),
                month: translate.instant('advanced-search.value.date.month'),
                day: translate.instant('advanced-search.value.date.day')
            }
        },
        search: {
            placeholder: translate.instant('ui.search'),
            noResultsMsg: translate.instant('ui.no-results'),
            listCappedMsg: translate.instant('ui.load-more')
        }
    }
});
